import { Draft } from '@reduxjs/toolkit';
import {
  IRetentionQueryFieldsFragment,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { INextStepType } from '../../cachedEntities';
import { assertCondition, byTypeName } from '../../../../utils/types';
import { IBuilder, RowType } from '../types';
import { generateMeasureRowsFromEventConditions } from './utils';

const prepareRetentionToNextStep = (
  draft: Draft<IBuilder>,
  builderInfo: IRetentionQueryFieldsFragment,
  targetType: INextStepType,
) => {
  assertCondition(targetType !== QueryType.Retention);
  const { startConditions, returnConditions, subject } = builderInfo;

  if (targetType === QueryType.Expression) {
    draft[RowType.measures] = generateMeasureRowsFromEventConditions(
      [startConditions, returnConditions],
      draft.defaultMeasureFunctions,
      subject?.name ?? null,
    );
  } else if (targetType === QueryType.DataTable) {
    draft[RowType.dataTableMeasures] = generateMeasureRowsFromEventConditions(
      [startConditions, returnConditions],
      draft.defaultMeasureFunctions,
      subject?.name ?? null,
    );
  } else if (targetType === QueryType.Path) {
    // In Path we have Starting and Ending events
    // ANY can't be used as starting events
    const startingEventConditions = startConditions
      // filter all ANY event conditions
      .filter(
        (eventCondition) =>
          eventCondition.events.filter(byTypeName('AnyEvent')).length === 0,
      );

    if (startingEventConditions.length > 0) {
      draft[RowType.paths][0] = startingEventConditions;
    }

    draft[RowType.paths][1] = returnConditions;
  } else if (targetType === QueryType.Funnel) {
    const firstStepConditions = startConditions
      // ANY event's shouldn't carry over
      .filter(
        (eventCondition) =>
          eventCondition.events.filter(byTypeName('AnyEvent')).length === 0,
      );
    if (firstStepConditions.length > 0) {
      draft[RowType.steps][0].eventConditions = firstStepConditions;
    }

    const secondStepConditions = returnConditions
      // ANY event's shouldn't carry over
      .filter(
        (eventCondition) =>
          eventCondition.events.filter(byTypeName('AnyEvent')).length === 0,
      );
    if (secondStepConditions.length > 0) {
      draft[RowType.steps][1].eventConditions = secondStepConditions;
    }
  }
};

export default prepareRetentionToNextStep;
